import { Instance, SnapshotOut, types } from "mobx-state-tree"
import { IExtubationInputData, ExtubationInputData } from './ExtubationInputData';
import { IExtubationResults, ExtubationResults } from './ExtubationResults';

/**
 * # ExtubationPatients
 * 
 * ExtubationPatients을 설명하세요.
 */
export const ExtubationPatients = types
  .model('ExtubationPatients')
  // --------------------------------------------------------------------------
  .props({
    일련번호: types.optional(types.number, 0),
    이름: types.optional(types.string, ''),
    input_data: types.optional(ExtubationInputData, {} as IExtubationInputData),
    results: types.optional(ExtubationResults, {} as IExtubationResults),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model extubationPatients --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IExtubationPatients;
      (Object.keys(newProps) as TExtubationPatientsKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TExtubationPatients = Instance<typeof ExtubationPatients>;
type TExtubationPatientsSnapshot = SnapshotOut<typeof ExtubationPatients>

export interface IExtubationPatients extends TExtubationPatients {}
export type TExtubationPatientsKeys = keyof TExtubationPatientsSnapshot & string;
export interface IExtubationPatientsSnapshot extends TExtubationPatientsSnapshot {}
export const createExtubationPatients = () => 
  types.optional(ExtubationPatients, {} as TExtubationPatients);